import { authorizationStore } from '@frontend/authorization';
import { packageStore } from '@frontend/package/redux';
import { productStore } from '@frontend/product/redux';
import { entityCreateSignalStore, listStore, resolveStore } from '@frontend/repository';
import { mobileWizardStore } from '@frontend/wizard/mobile';
import { workflowStepStore } from '@frontend/workflow-step/redux';
import { workflowSharedStore, workflowStore } from '@frontend/workflow/redux';
import { configureStore } from '@reduxjs/toolkit';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import { navigationStore } from './terminal-navigation-slice';

export const store = configureStore({
    reducer: {
        ...workflowStore,
        ...workflowStepStore,
        ...authorizationStore,
        ...workflowSharedStore,
        ...productStore,
        ...packageStore,
        ...listStore,
        ...entityCreateSignalStore,
        ...resolveStore,
        ...mobileWizardStore,

        //terminal states
        ...navigationStore
    }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
